<script>
  import { Link } from "svelte-routing";
  import { _ as t } from "svelte-i18n";

  export let links = undefined;
</script>

{#if links}
  <h3 class="breadcrumb-links">
    <Link to="/">{$t("dashboard")}</Link>
    {#each links as link}
      {#if link}
        <span>/</span>
        <Link to={link.to}>{link.label}</Link>
      {:else}<span>/</span> <span>{$t("loading")}</span>{/if}
    {/each}
  </h3>
{:else}
  <h3>
    <slot />
  </h3>
{/if}

<style>
  h3 {
    margin: 0;
    padding: 18px 0;
    font-size: 20px;
    font-weight: 100;
    color: var(--blue-color);
  }

  :global(.breadcrumb-links > :last-child) {
    font-weight: 700;
  }
</style>
